<template>
  <div class="d-flex flex-column justify-center">
    <v-dialog v-model="dialog" :width="responsiveWidth">
      <template v-slot:activator="{ on }">
        <v-btn
          x-large
          color="accent"
          v-ripple
          class="font-weight-black mt-0 elevation-24 text-h6"
          v-on="on"
          @click="initFirebase"
          :width="buttonWidth"
        >
          Sign Up
        </v-btn>
      </template>
      <v-card>
        <v-container class="d-flex flex-column justify-center pt-0">
          <v-row>
            <v-spacer></v-spacer>
            <v-btn icon @click="dialog = !dialog">
              <v-icon color="grey lighten-1">{{ mdiCloseBox }}</v-icon>
            </v-btn>
          </v-row>

          <v-row class="justify-center">
            <!-- <v-col

                        > -->
            <v-card-title
              :class="[$vuetify.breakpoint.xs ? 'headline' : 'display-1']"
              class="title-fix text-center mb-0 pt-0"
            >
              Sign Up for our Newsletter!
            </v-card-title>
          </v-row>
          <v-card-text>
            <v-row>
              <!-- <v-container> -->
              <!-- <v-row class="text-left title-fix"> -->
              There are tons of exciting new developments in store at MicroTone Guitars. We're
              constantly refining our designs to bring you the most advanced interchangeable
              fretboards in the world. To stay up to date on everything that's happening, sign up
              for our newsletter.
              <!-- </v-row> -->
              <!-- </v-container> -->
            </v-row>
            <v-row class="d-flex flex-column justify-center mt-5">
              <v-form
                class="d-flex flex-column justify-center"
                v-model="validEmail"
                ref="form"
                @submit.prevent="submitEmail"
              >
                <v-col md="8" lg="6" align-self="center" align="center">
                  <v-text-field
                    v-model="email"
                    label="Email Address (required)"
                    type="email"
                    placeholder="you@mail.com"
                    filled
                    shaped
                    :append-icon="mdiEmailPlus"
                    :rules="emailRules"
                    @keydown.enter="$event.stopPropagation()"
                  >
                    <!-- append-icon="mdi-email-plus" -->
                    <!-- The keydown.enter is to suppress Lastpass errors -->
                  </v-text-field>

                  <v-text-field
                    class="pt-0"
                    v-model="fName"
                    label="First Name"
                    type="text"
                    :rules="nameRules"
                    @keydown.enter="$event.stopPropagation()"
                  >
                  </v-text-field>

                  <v-text-field
                    class="pt-0"
                    v-model="lName"
                    label="Last Name"
                    type="text"
                    :rules="nameRules"
                    @keydown.enter="$event.stopPropagation()"
                  >
                  </v-text-field>

                  <v-btn
                    x-large
                    color="accent"
                    v-ripple
                    class="thicc mt-0 elevation-24"
                    block
                    :disabled="!validEmail"
                    @click="submitEmail"
                    v-if="!isProcessing"
                  >
                    Sign Up
                  </v-btn>
                  <v-progress-circular v-else indeterminate color="accent" class="ma-1">
                  </v-progress-circular>
                  <p class="mt-5">
                    By signing up, you consent to our awesome
                    <privacy-policy />
                  </p>
                </v-col>
              </v-form>
            </v-row>
          </v-card-text>

          <!-- </v-col> -->
          <!-- </v-row> -->

          <!-- This is stuff from the Tinyletter new sub signup. It's kinda terrible. -->
          <!-- <v-form style="border:1px solid #ccc;padding:3px;text-align:center;"
                    action="https://tinyletter.com/jknudstrup"
                    method="post"
                    target="popupwindow"
                    onsubmit="window.open('https://tinyletter.com/jknudstrup', 'popupwindow', 'scrollbars=yes,width=800,height=600');return true">
                        <p>
                            <label for="tlemail">Enter your email address</label>
                        </p>
                        <p>
                            <input type="text" style="width:140px" name="email" id="tlemail" />
                        </p>
                        <input type="hidden" value="1" name="embed"/>
                        <input type="submit" value="Subscribe" />
                        <p>
                            <a href="https://tinyletter.com" target="_blank">powered by TinyLetter</a>
                        </p>
                    </v-form> -->
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mdiCloseBox, mdiEmailPlus } from '@mdi/js';
// let context;

// Testing
// import { currentDomain } from '../firebaseConfig';
// import { appCheck } from '../firebaseConfig';
// import { httpsCallable } from 'firebase/functions';
const getHttpsCallable = () => import('firebase/functions');

// import firebase from '../firebaseConfig';

const importFirebase = () => import('../firebaseConfig');
const importFirestoreMethods = () => import('firebase/firestore/lite');
// const getAppCheck = () => import('../')
// const firebaseInit = () => await import('../firebaseConfig');
// const importHttpsCallable = () => import('firebase/functions');
// const appInit = () => import('../firebaseConfig');

// const db = firebase.firestore();
// console.log(db);
// let db;
let addEmail;
// let db;
let subscriptionAttemptsCollection;
// let collection;
let fsTime;
let pushAttempt;

export default {
  data() {
    return {
      // buttonWidth: 'auto',
      dialog: false, // Default this to 'false' for production
      email: '',
      fName: '',
      lName: '',
      domain: '',
      validEmail: false,
      isProcessing: false,
      mdiCloseBox,
      mdiEmailPlus,
      errorMsg: '',
      badEmails: {},
      nameRules: [(v) => v.length <= 50 || 'Name length cant exceed 50 characters!'],
      emailRules: [
        (value) => !Object.keys(this.badEmails).includes(value) || this.badEmails[value],
        (value) => !!value || 'Type in your email address!',
        (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Must be a valid email address!';
        },
      ],
    };
  },
  props: {
    buttonWidth: {
      type: [String, Number],
      default: 'auto',
    },
  },
  computed: {
    /*
    Necessary because you apparently can't use a grid to resize a v-dialog. Yay!
    */
    responsiveWidth() {
      let width = 'auto';
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          width = 'auto';
          break;
        case 'sm':
          width = '500';
          break;
        default:
          width = '800';
      }
      return width;
    },
  },
  methods: {
    // updateValidation() {
    //   this.validEmail = this.$refs.form.validate();
    // },
    async initFirebase() {
      // Test stuff
      // console.log(process.env);
      // console.log(window.location.hostname);
      // this.env = process.env.NODE_ENV;
      // console.log(`Will this work? ${Object.keys(process.env)}`);
      // console.log(process.env.BASE_URL);

      // this.nodEnv = process.env.NODE_ENV;

      const { httpsCallable } = await getHttpsCallable();
      const { firestore, functions, currentDomain } = await importFirebase();

      const { collection, addDoc, serverTimestamp } = await importFirestoreMethods();
      // db = firestore;
      // console.log(`What exactly is a collection? ${collection}`);
      subscriptionAttemptsCollection = collection(firestore, 'subscriptionAttempts');
      pushAttempt = addDoc;
      fsTime = serverTimestamp;

      // Firestore write test block
      // const testObj = { foo: 'bar', date: Date.now() };
      // const docRef = await addDoc(subscriptionAttempts, testObj);
      // console.log(`Document written with ID ${docRef.id}`);


      // Get rid of this for prod!!!!
      // eslint-disable-next-line
      // console.log(`Current domain: ${currentDomain}`);
      this.domain = currentDomain;
      // app();
      // appCheck();
      addEmail = httpsCallable(functions, 'addEmail');

      // const verifyAppCheck = httpsCallable(functions, 'appCheckCheck ');
      // verifyAppCheck({});
    },
    submitEmail() {
      // console.log('This is what db is:');
      // console.log(db.then(console.log()));
      let success;

      if (this.$refs.form.validate()) {
        this.validEmail = true;
        this.isProcessing = true;
        // Firebase stuff here
        // db.collection('emailAddresses')
        //   .doc(this.email)
        //   .set({
        //     created: Date.now(),
        //   }).then(() => {
        //     this.$store.dispatch('toggleSnackbar');
        //     this.dialog = false;
        //   })
        //   .catch(() => null);

        addEmail({
          email: this.email,
          fName: this.fName,
          lName: this.lName,
          domain: this.domain,
        })
          .then(() => {
            success = true;
            this.$store.dispatch('toggleSnackbar');
            this.dialog = false;
          })
          .catch((err) => {
            success = false;
            this.errorMsg = err.message;
            // eslint-disable-next-line no-console
            console.log(`${err.details}`);
            // this.badEmails.push({ email: this.email, title: err.title });
            this.badEmails[this.email] = err.message;
            // this.emailRules.push(email => email)
            this.$refs.form.validate();
          })
          .then(() => {
            this.isProcessing = false;
            // Log subscription attempt
            pushAttempt(subscriptionAttemptsCollection, {
              emailAddress: this.email,
              firstName: this.fName,
              lastName: this.lName,
              date: fsTime(),
              dateCode: Date.now(),
              success,
            });
          });
        // this.isProcessing = false;
      } else {
        this.validEmail = false;
      }
    },
  },
};
</script>

<style scoped>
.title-fix {
  word-break: normal;
}

.thicc {
  font-weight: 900;
}
</style>
